// Libellés du rythme de gratuité (paramétrable dans le Super Admin)
export const FREE_PERIOD_LABELS = {
  jour: "chaque jour",
  semaine: "chaque semaine",
  mois: "chaque mois",
  trimestre: "chaque trimestre",
  année: "chaque année",
  unique: "en une seule fois", // Instants offerts non renouvelables (Julie, 21/10/2026)
};

export const FREE_PERIOD_HOME = {
  jour: "aujourd'hui",
  semaine: "cette semaine",
  mois: "ce mois-ci",
  trimestre: "ce trimestre",
  année: "cette année",
  unique: "en tout",
};

export const freePeriodLabel = (period) => FREE_PERIOD_LABELS[period] || FREE_PERIOD_LABELS.semaine;

export const freePeriodHome = (period) => FREE_PERIOD_HOME[period] || FREE_PERIOD_HOME.semaine;
